import { render, staticRenderFns } from "./line.md?vue&type=template&id=60ba6b9e&"
import script from "./line.md?vue&type=script&lang=js&"
export * from "./line.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ba6b9e')) {
      api.createRecord('60ba6b9e', component.options)
    } else {
      api.reload('60ba6b9e', component.options)
    }
    module.hot.accept("./line.md?vue&type=template&id=60ba6b9e&", function () {
      api.rerender('60ba6b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/scatter/line.md"
export default component.exports